/**
 * Compare-mode policy for media edits in the post inspector.
 *
 * Founder decision (spec §3, row 3): scheduled posts are high-stakes — an AI
 * media swap must show an explicit Original ⇄ Revised compare with Keep/Revert.
 * Every other editable status (draft / pending_review / failed /
 * partially_failed) keeps the fast path: instant swap + an Undo toast.
 *
 * Centralized here so the media manager, the carousel slot toggle, and the
 * variation-candidate picker all read ONE source of truth (never re-derive the
 * status check inline).
 */
export type CompareMode = 'compare' | 'instant';

/** The only status that gets explicit Keep/Revert compare. */
export const COMPARE_STATUSES = ['scheduled'] as const;

export function compareModeForStatus(status: string | null | undefined): CompareMode {
  return status != null && COMPARE_STATUSES.includes(status as (typeof COMPARE_STATUSES)[number])
    ? 'compare'
    : 'instant';
}
